export default "__VITE_ASSET__34082af0__"